import React, { Component } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import AssignTagModal from "./addTagModal";

const avatarColors = [
    "#f44336", "#e91e63", "#9c27b0", "#673ab7",
    "#3f51b5", "#2196f3", "#03a9f4", "#00bcd4",
    "#009688", "#4caf50", "#8bc34a", "#cddc39",
    "#ffeb3b", "#ffc107", "#ff9800", "#ff5722",
];

const getAvatarColor = (str) => {
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
        hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }
    return avatarColors[Math.abs(hash) % avatarColors.length];
};

class ConvoNavBar extends Component {
    constructor(props) {
        super(props);
        this.state = { isMobile: window.matchMedia("(max-width:900px)").matches };
        this.scrollRef = React.createRef();
    }

    componentDidMount() {
        this.mediaQuery = window.matchMedia("(max-width:900px)");
        this.handleMQ = (e) => this.setState({ isMobile: e.matches });
        this.mediaQuery.addEventListener("change", this.handleMQ);
    }

    componentWillUnmount() {
        if (this.mediaQuery) this.mediaQuery.removeEventListener("change", this.handleMQ);
    }

    render() {
        const {
            selectedUser, waMessageContacts = [], addTagModal,
            openLeadChatConvo, onBack, onCloseTagModal,
            onCloseLeadChat, getTags = [], onUpdateTags,
        } = this.props;

        const { isMobile } = this.state;

        const contact = waMessageContacts.find((item) => item.wa_contact_id === selectedUser);

        return (
            <div>
                <div style={{
                    backgroundColor: "#f0f2f5",
                    height: 60,
                    display: "flex", alignItems: "center",
                    justifyContent: "space-between",
                    padding: "0 16px",
                    color: "#111b21",
                }}>
                    {/* Left: back/avatar + name */}
                    <div style={{ display: "flex", alignItems: "center", overflow: "hidden" }}>
                        <OverlayTrigger placement="top" overlay={<Tooltip id="profile-tip">Update Profile</Tooltip>}>
                            {isMobile ? (
                                <button
                                    className="btn btn-link p-0 mr-2"
                                    style={{ color: "#54656f" }}
                                    onClick={() => {
                                        if (openLeadChatConvo) {
                                            onCloseLeadChat && onCloseLeadChat();
                                        } else {
                                            onBack && onBack();
                                        }
                                    }}
                                >
                                    <i className="fas fa-arrow-left" />
                                </button>
                            ) : (
                                <div style={{
                                    width: 35, height: 35, borderRadius: "50%",
                                    backgroundColor: getAvatarColor((contact?.name || "") + (contact?.wa_contact_id || "")),
                                    display: "flex", alignItems: "center", justifyContent: "center",
                                    fontWeight: "bold", fontSize: 15, cursor: "pointer",
                                    marginRight: 8,
                                }}>
                                    {contact?.name?.[0] || "?"}
                                </div>
                            )}
                        </OverlayTrigger>

                        <div style={{ display: "flex", flexDirection: "column", overflow: "hidden", lineHeight: 1.2 }}>
                            <span style={{ fontSize: 15, fontWeight: 600, cursor: "pointer", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                                {contact?.name ?? contact?.mobile}
                            </span>
                            {contact?.name && contact?.mobile && (
                                <span style={{ fontSize: 12, color: "#667781", whiteSpace: "nowrap" }}>
                                    {contact.mobile}
                                </span>
                            )}
                        </div>
                    </div>

                    {/* Right: org icon + close */}
                    <div className="d-flex align-items-center">
                        {contact?.organisation_ids !== null && (
                            <OverlayTrigger
                                placement="bottom"
                                overlay={<Tooltip id="org-tip">{contact?.organisation_names}</Tooltip>}
                            >
                                <button className="btn btn-link p-0 ml-1" style={{ color: "#54656f" }}>
                                    <i className="fas fa-building" />
                                </button>
                            </OverlayTrigger>
                        )}
                        {openLeadChatConvo && (
                            <button
                                className="btn btn-link p-0 ml-1"
                                style={{ color: "#54656f" }}
                                title="Close"
                                onClick={() => onCloseLeadChat && onCloseLeadChat()}
                            >
                                <i className="fas fa-times" />
                            </button>
                        )}
                    </div>
                </div>

                <AssignTagModal
                    show={addTagModal}
                    handleClose={() => onCloseTagModal && onCloseTagModal()}
                    selectedUser={selectedUser}
                    waMessageContacts={waMessageContacts}
                    getTags={getTags}
                    onUpdateTags={onUpdateTags}
                />
            </div>
        );
    }
}

export default ConvoNavBar;
